import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import { useStore } from "vuex";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const { getHeader, getFooter } = pdfHeaderFooter();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, data, startDate, endDate, qrcode) => {
        const doc = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName, qrcode),
            content: getContent(data, startDate, endDate),
            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Sales Collection Report'
            }
        }

        pdfMake.createPdf(doc).open();
    }

    const getContent = (data, startDate, endDate) => {
        const { rows, totals, mop_heads: mopHeads } = data;

        return [
            {
                text: 'Sales Collection Report',
                fontSize: 14,
                bold: true,
                alignment: 'center',
                decoration: 'underline',
                margin: [0, 0, 0, 4]
            },
            {
                text: `Date: ${startDate} - ${endDate}`,
                margin: [0, 0, 0, 8]
            },
            {
                fontSize: 8,
                table: {
                    widths: getColumnWidths(mopHeads),
                    body: getTableBody(rows, totals, mopHeads)
                },
                layout: {
                    fillColor: (rowIndex) => rowIndex === 0 ? '#f3f2f7' : null,
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5
                }
            }
        ]
    }

    const getColumnWidths = (mopHeads) => {
        const fixed = ['auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
        return [...fixed, ...mopHeads.map(() => 'auto')];
    }

    const getTableBody = (rows, totals, mopHeads) => {
        const header = [
            { text: 'Date', bold: true },
            { text: 'Type', bold: true },
            { text: 'Reference No.', bold: true },
            { text: 'Client Details', bold: true },
            { text: 'SubTotal', bold: true, alignment: 'right' },
            { text: 'VAT', bold: true, alignment: 'right' },
            { text: 'Discount', bold: true, alignment: 'right' },
            { text: 'Redeem Pt.', bold: true, alignment: 'right' },
            { text: 'Bill Amount', bold: true, alignment: 'right' },
            { text: 'Paid Amount', bold: true, alignment: 'right' },
            ...mopHeads.map(m => ({ text: m.label, bold: true, alignment: 'right' }))
        ];

        const dataRows = rows.map(item => {
            const refText = item.return_ref ? `${item.bill_number} [Ref # ${item.return_ref}]` : item.bill_number;
            return [
                { text: item.date, color: item.is_return ? 'red' : 'black' },
                { text: item.type, color: item.is_return ? 'red' : 'black' },
                { text: refText, color: item.is_return ? 'red' : 'black' },
                { text: item.client_details, color: item.is_return ? 'red' : 'black' },
                { text: commaFormat(item.subtotal_amount), alignment: 'right', color: item.is_return ? 'red' : 'black' },
                { text: commaFormat(item.vat_amount), alignment: 'right', color: item.is_return ? 'red' : 'black' },
                { text: commaFormat(item.discount_amount), alignment: 'right', color: item.is_return ? 'red' : 'black' },
                { text: commaFormat(item.redeem_point), alignment: 'right', color: item.is_return ? 'red' : 'black' },
                { text: commaFormat(item.bill_amount), alignment: 'right', color: item.is_return ? 'red' : 'black' },
                { text: commaFormat(item.paid_amount), alignment: 'right', color: item.is_return ? 'red' : 'black' },
                ...mopHeads.map(m => ({
                    text: commaFormat((item.mop_heads && item.mop_heads[m.key]) || 0),
                    alignment: 'right',
                    color: item.is_return ? 'red' : 'black'
                }))
            ];
        });

        const totalRow = [
            { text: 'Total', bold: true, colSpan: 4 }, {}, {}, {},
            { text: commaFormat(totals.subtotal_amount), bold: true, alignment: 'right' },
            { text: commaFormat(totals.vat_amount), bold: true, alignment: 'right' },
            { text: commaFormat(totals.discount_amount), bold: true, alignment: 'right' },
            { text: commaFormat(totals.redeem_point), bold: true, alignment: 'right' },
            { text: commaFormat(totals.bill_amount), bold: true, alignment: 'right' },
            { text: commaFormat(totals.paid_amount), bold: true, alignment: 'right' },
            ...mopHeads.map(m => ({
                text: commaFormat((totals.mop_heads && totals.mop_heads[m.key]) || 0),
                bold: true,
                alignment: 'right'
            }))
        ];

        return [header, ...dataRows, totalRow];
    }

    return { exportToPDF }
}

export default pdfPrinter;
